// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// 36 CSS-animierte Teilchen (Rechteck/Punkt/Blatt) in Moos/Salbei/Sand.
// ponytail: alles deterministisch aus dem Index abgeleitet — kein Math.random im Render,
// damit React-Re-Renders keine springenden Teilchen erzeugen.
const FARBEN = ["var(--moos)", "var(--salbei)", "var(--sand)"]
const FORMEN = ["rect", "dot", "blatt"]
const ANZAHL = 36

/** `menge` skaliert die Teilchenzahl (Feier-Stufe in den Optionen). */
export default function Confetti({ menge = 1 }: { menge?: number }) {
  return (
    <div className="celebration-confetti">
      {Array.from({ length: Math.round(ANZAHL * menge) }, (_, i) => {
        const links = (i * 37) % 100 // Prozent
        const delay = ((i * 53) % 40) / 100 // 0 – 0.39 s
        const dauer = 1.6 + ((i * 29) % 50) / 100 // 1.6 – 2.09 s
        const groesse = 5 + ((i * 13) % 5) // 5 – 9 px
        const form = FORMEN[i % 3]
        return (
          <span
            key={i}
            className={
              "confetti-piece confetti-piece--" + form + (i % 2 ? " confetti-piece--links" : "")
            }
            style={{
              left: `${links}%`,
              width: groesse,
              height: form === "rect" ? Math.round(groesse * 1.6) : groesse,
              background: FARBEN[Math.floor(i / 3) % 3],
              animationDelay: `${delay}s`,
              animationDuration: `${dauer}s`,
            }}
          />
        )
      })}
    </div>
  )
}
